export default "__VITE_ASSET__BJ9FAU4b__";